/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMergeEvent
 */
export interface MdmMergeEvent {
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    eventType?: string;
    /**
     * 
     * @type {Date}
     * @memberof MdmMergeEvent
     */
    eventAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    actor?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMergeEvent
     */
    decisiveTier?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMergeEvent
     */
    tierShortCircuited?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMergeEvent
     */
    matchedRules?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MdmMergeEvent
     */
    guardResults?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMergeEvent
     */
    sourceEntityIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmMergeEvent
     */
    beforeGoldenId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmMergeEvent
     */
    afterGoldenIds?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MdmMergeEvent
     */
    detail?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MdmMergeEvent interface.
 */
export function instanceOfMdmMergeEvent(value: object): value is MdmMergeEvent {
    return true;
}

export function MdmMergeEventFromJSON(json: any): MdmMergeEvent {
    return MdmMergeEventFromJSONTyped(json, false);
}

export function MdmMergeEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMergeEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'eventType': json['eventType'] == null ? undefined : json['eventType'],
        'eventAt': json['eventAt'] == null ? undefined : (new Date(json['eventAt'])),
        'actor': json['actor'] == null ? undefined : json['actor'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'decisiveTier': json['decisiveTier'] == null ? undefined : json['decisiveTier'],
        'tierShortCircuited': json['tierShortCircuited'] == null ? undefined : json['tierShortCircuited'],
        'matchedRules': json['matchedRules'] == null ? undefined : json['matchedRules'],
        'guardResults': json['guardResults'] == null ? undefined : json['guardResults'],
        'sourceEntityIds': json['sourceEntityIds'] == null ? undefined : json['sourceEntityIds'],
        'beforeGoldenId': json['beforeGoldenId'] == null ? undefined : json['beforeGoldenId'],
        'afterGoldenIds': json['afterGoldenIds'] == null ? undefined : json['afterGoldenIds'],
        'detail': json['detail'] == null ? undefined : json['detail'],
    };
}

export function MdmMergeEventToJSON(json: any): MdmMergeEvent {
    return MdmMergeEventToJSONTyped(json, false);
}

export function MdmMergeEventToJSONTyped(value?: MdmMergeEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'entityType': value['entityType'],
        'goldenRecordId': value['goldenRecordId'],
        'eventType': value['eventType'],
        'eventAt': value['eventAt'] == null ? undefined : ((value['eventAt']).toISOString()),
        'actor': value['actor'],
        'reason': value['reason'],
        'decisiveTier': value['decisiveTier'],
        'tierShortCircuited': value['tierShortCircuited'],
        'matchedRules': value['matchedRules'],
        'guardResults': value['guardResults'],
        'sourceEntityIds': value['sourceEntityIds'],
        'beforeGoldenId': value['beforeGoldenId'],
        'afterGoldenIds': value['afterGoldenIds'],
        'detail': value['detail'],
    };
}

